export default "/images/efd366d5aba5ba776be7cb76497be5e8.png";